import { AngularFirestore } from 'angularfire2/firestore';
import { DataModel, IDataModel } from './data.model';
import { TextSearch } from '../comum/textSearch';


export interface ILocalidades extends IDataModel {
    nome?: string;
    estado?: string;
    img?: string;
    distancia?: number;
    latitude?: number;
    longitude?: number;
    location?: any;
}

export class Localidades extends DataModel<ILocalidades>  {
    constructor(private db: AngularFirestore) {
        super(db, 'localidades');
    }


    updateOrInsert(id, item, proc, err) {
        item.id = id;
        if (!item.id) {
           item.id = TextSearch.clear( item.nome ).replace('/', '-');
        }
        return super.updateOrInsert(item.id, item, r => {
            if (proc) {
                proc(r); }
        }, err);
    }

}
